export default {"src":"/_next/static/media/zoom-atlas.00eb40e4.svg","height":64,"width":64};